import React from 'react';
import { Box, TextField, Typography } from '@material-ui/core';
import ErrorRoundedIcon from '@material-ui/icons/ErrorRounded';
interface FormFieldProps {
  id: string;
  label: string;
  type: string;
  placeholder?: string;
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onBlur: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  error?: string;
  required?: boolean;
}

export const FormField = ({
  id,
  label,
  type,
  placeholder,
  value,
  onChange,
  onBlur,
  error,
  required,
}: FormFieldProps) => {
  return (
    <Box className="apm-form-group">
      <Typography component="label" htmlFor={id} className="apm-form-label">
        {label}
        {required && <span className="apm-required">*</span>}
      </Typography>
      <TextField
        type={type}
        id={id}
        name={id}
        variant="outlined"
        size="small"
        fullWidth
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        error={Boolean(error)}
        helperText={
          error ? (
            <span className="apm-field-error">
              <ErrorRoundedIcon className="apm-field-error-icon" />
              {error}
            </span>
          ) : undefined
        }
      />
    </Box>
  );
};
